import axios from "axios";
import { API_PROSPECTS_APPOINTMENTS_URL, API_PROSPECTS_URL } from "../utils/constants";
import { handleServiceError } from "../utils/helpers";

export const getProspects = async (size: number, page: number, search?: string, sort: string = "createdAt,desc") => {
    const token = localStorage.getItem("access_token");
    try {
        const searchParam = search ? `&search=${search}` : "";
        const response = await axios.get(
            `${API_PROSPECTS_URL}?page=${page}&size=${size}&sort=${sort}${searchParam}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

export const getProspectsAppointments = async (size: number, page: number, sort: string = "createdAt,desc", search?: string, status?: string) => {
    const token = localStorage.getItem("access_token");
    try {
        const searchParam = search ? `&search=${search}` : "";
        const statusParam = status ? `&status=${status}` : "";
        const response = await axios.get(
            `${API_PROSPECTS_APPOINTMENTS_URL}?page=${page}&size=${size}&sort=${sort}${searchParam}${statusParam}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

export const getProspectsAppointmentById = async (id: string) => {
    const token = localStorage.getItem("access_token");
    try {
        const response = await axios.get(
            `${API_PROSPECTS_APPOINTMENTS_URL}/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

export const updateProspectAppointment = async (prospectAppointmentId: string, payload: any) => {
    const token = localStorage.getItem("access_token");
    try {
        const response = await axios.put(`${API_PROSPECTS_APPOINTMENTS_URL}/${prospectAppointmentId}`, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

export const createFollowUpAppointment = async (prospectAppointmentId: string, payload: any) => {
    const token = localStorage.getItem("access_token");
    try {
        const response = await axios.post(`${API_PROSPECTS_APPOINTMENTS_URL}/${prospectAppointmentId}/follow-up`, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

export const getProspectById = async (prospectId: string | undefined) => {
    const token = localStorage.getItem("access_token");
    try {
        const response = await axios.get(
            `${API_PROSPECTS_URL}/${prospectId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

export const getAssignments = async (size: number, page: number, search?: string, sort: string = "createdAt,desc") => {
    const token = localStorage.getItem("access_token");
    try {
        let url = `${API_PROSPECTS_APPOINTMENTS_URL}/assigned`;
        url += `?page=${page}&size=${size}&sort=${sort}`;
        url += search ? `&search=${search}` : "";
        const response = await axios.get(
            `${url}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

export const getInTracingAttended = async (size: number, page: number, search?: string, sort: string = "createdAt,desc") => {
    const token = localStorage.getItem("access_token");
    try {
        let url = `${API_PROSPECTS_APPOINTMENTS_URL}/tracing/attended`;
        url += `?page=${page}&size=${size}&sort=${sort}`;
        url += search ? `&search=${search}` : "";
        const response = await axios.get(
            `${url}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

export const getInTracingRequired = async (size: number, page: number, search?: string, sort: string = "createdAt,desc") => {
    const token = localStorage.getItem("access_token");
    try {
        let url = `${API_PROSPECTS_APPOINTMENTS_URL}/tracing/required`;
        url += `?page=${page}&size=${size}&sort=${sort}`;
        url += search ? `&search=${search}` : "";
        const response = await axios.get(
            `${url}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

export const getCompletedProspects = async (size: number, page: number, sort: string = "createdAt,desc", search?: string, saleStatus?: string) => {
    const token = localStorage.getItem("access_token");
    try {
        let url = `${API_PROSPECTS_URL}/completed?page=${page}&size=${size}&sort=${sort}`;
        url += search ? `&search=${search}` : "";
        url += saleStatus ? `&saleStatus=${saleStatus}` : "";
        const response = await axios.get(
            `${url}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

export const getCompletedProspectsForOrder = async (
    size: number,
    page: number,
    sort: string = "createdAt,desc",
    search?: string
) => {
    const token = localStorage.getItem("access_token");
    try {
        let url = `${API_PROSPECTS_APPOINTMENTS_URL}/completed-to-order?page=${page}&size=${size}&sort=${sort}`;
        url += search ? `&search=${search}` : "";
        const response = await axios.get(`${url}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

export const createProspect = async (payload: any) => {
    const token = localStorage.getItem("access_token");
    try {
        const response = await axios.post(`${API_PROSPECTS_URL}/init`, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

export const updateProspect = async (prospectId: string, payload: any) => {
    const token = localStorage.getItem("access_token");
    try {
        const response = await axios.put(`${API_PROSPECTS_URL}/${prospectId}`, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

export const createProspectPerson = async (prospectId: string, payload: any) => {
    const token = localStorage.getItem("access_token");
    try {
        const response = await axios.post(`${API_PROSPECTS_URL}/${prospectId}/persons`, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

export const updateProspectPerson = async (prospectId: string, personId: string, payload: any) => {
    const token = localStorage.getItem("access_token");
    try {
        const response = await axios.put(`${API_PROSPECTS_URL}/${prospectId}/persons/${personId}`, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

export const createProspectAddress = async (prospectId: string, payload: any) => {
    const token = localStorage.getItem("access_token");
    try {
        const response = await axios.post(`${API_PROSPECTS_URL}/${prospectId}/address`, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

export const updateProspectAddress = async (prospectId: string, personId: string, payload: any) => {
    const token = localStorage.getItem("access_token");
    try {
        const response = await axios.put(`${API_PROSPECTS_URL}/${prospectId}/address/${personId}`, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

export const deleteProspect = async (id: string | undefined) => {
    const token = localStorage.getItem("access_token");
    try {
        const response = await axios.delete(
            `${API_PROSPECTS_URL}/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

export const rescheduleProspectAppointmentById = async (prospectAppointmentId: string, newAppointmentDate: Date) => {
    const token = localStorage.getItem("access_token");
    try {
        const newAppointment = newAppointmentDate.toISOString();
        const url = `${API_PROSPECTS_APPOINTMENTS_URL}/${prospectAppointmentId}/reschedule?appointment=${newAppointment}`;
        const response = await axios.put(url, null, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

export const markProspectVisitedById = async (id: string | undefined, latitude?: number, longitude?: number) => {
    const token = localStorage.getItem("access_token");
    try {
        let url = `${API_PROSPECTS_APPOINTMENTS_URL}/${id}/visit`;
        if (latitude && longitude) {
            url += `?latitude=${latitude}&longitude=${longitude}`;
        }
        const response = await axios.put(url, null, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

export const cancelAppointmentById = async (prospectAppointmentId: string, cancellationCause: string) => {
    const token = localStorage.getItem("access_token");
    try {
        const url = `${API_PROSPECTS_APPOINTMENTS_URL}/${prospectAppointmentId}/cancel?reason=${cancellationCause}`;
        const response = await axios.put(url, null, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

export const markProspectQuotedById = async (prospectAppointmentId: string) => {
    const token = localStorage.getItem("access_token");
    try {
        const url = `${API_PROSPECTS_APPOINTMENTS_URL}/${prospectAppointmentId}/quote`;
        const response = await axios.put(url, null, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

export const markProspectTrackedById = async (id: string, currentTraceNumber: number, tracingNotes: string) => {
    const token = localStorage.getItem("access_token");
    try {
        const url = `${API_PROSPECTS_APPOINTMENTS_URL}/${id}/tracing`;
        const response = await axios.post(url, {
            traceNumber: currentTraceNumber,
            notes: tracingNotes
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

export const updateProspectSaleStatusById = async (id: string, payload: any) => {
    const token = localStorage.getItem("access_token");
    try {
        const url = `${API_PROSPECTS_APPOINTMENTS_URL}/${id}/sale`;
        const response = await axios.put(url, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

// TODO: remove this method if is not used more
export const assignClientToProspect = async (id: string, clientId: string) => {
    const token = localStorage.getItem("access_token");
    try {
        const url = `${API_PROSPECTS_URL}/${id}/assign-client/${clientId}`;
        const response = await axios.put(url, null, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};

export const createOrderFromProspectAppointment = async (prospectAppointmentId: string) => {
    const token = localStorage.getItem("access_token");
    try {
        const url = `${API_PROSPECTS_APPOINTMENTS_URL}/${prospectAppointmentId}/order`;
        const response = await axios.post(url, null, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        return response;
    } catch (error: any) {
        handleServiceError(error);
    }
};
